(function($) {
    var numSlick = 0;
    var $sliderContainer = $('.slider-zoom-new');

    $sliderContainer.each(function() {
        numSlick++;

        $(this).addClass('slider-zoom-' + numSlick).slick({
            accessibility: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 8000,
            dots: false,
            fade: true,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            slickPause: true,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
        })
        .on('setPosition', function(event, slick) {
            $(slick.$slides).height('auto').css('height', $(slick.$slideTrack).height() + 'px');
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            // Remove underline classes from the outgoing slide
            var $currentSlide = $(slick.$slides[currentSlide]);
            $currentSlide.find('em').removeClass('is-visible short medium long');

            // Remove zoom animation class from all slides
            $('.image-zoom').removeClass('zoom-active');
        })
        .on('afterChange', function(event, slick, currentSlide) {
            var $currentSlide = $(slick.$slides[currentSlide]);

            // Add the animation class to the new active slide
            $currentSlide.find('.image-zoom').addClass('zoom-active');

            // Target <em> elements and apply underline classes
            $currentSlide.find('em').each(function() {
                var textLength = $(this).text().length;
                
                // Determine underline size based on text length
                if (textLength <= 5) {
                    $(this).addClass('short');
                } else if (textLength <= 15) {
                    $(this).addClass('medium');
                } else {
                    $(this).addClass('long');
                }

                // Make <em> elements visible when in an active slide
                $(this).addClass('is-visible');
            });
        });
    });

    // Trigger the initial slide animation after a slight delay
    setTimeout(function() {
        var $slider = $('.slider-zoom-new');
        
        // Manually set the first slide as active
        $slider.slick('slickGoTo', 0, true);

        // Start autoplay after the initial animation
        $slider.slick('slickPlay');
        
        // Add the animation class to the initial slide
        var $firstSlide = $slider.find('.slick-current');

        $firstSlide.find('.image-zoom').addClass('zoom-active');

        // Apply underline classes to <em> elements in the first slide
        $firstSlide.find('em').each(function() {
            var textLength = $(this).text().length;
            if (textLength <= 5) {
                $(this).addClass('short');
            } else if (textLength <= 15) {
                $(this).addClass('medium');
            } else {
                $(this).addClass('long');
            }
            $(this).addClass('is-visible');
        });

    }, 50);

})(jQuery);
